import apiClient from './client';

export const ClaimValidationAxiosInstance = apiClient;


